<script setup lang="ts">
import { ref } from 'vue'

import {SplideSlide} from '@splidejs/vue-splide'
import Content from '~/components/Common/Content.vue'
import PageHeader from '~/components/Product/LandingPages/PageHeader.vue'
import UspItem from '~/components/Product/LandingPages/UspItem.vue'
import CardList from '~/components/Product/LandingPages/CardList.vue'
import Faqs from '~/components/Product/LandingPages/Faqs.vue'
import Offer from '~/components/Product/LandingPages/Offer.vue'

import CaretRight from '~/public/images/products/primeshred/caret-right.svg'
import Background from '~/public/images/products/primeshred/background.webp'
import ProductHeader from '~/public/images/products/primeshred/product-header.webp'

import Dartboard from '~/public/images/products/primeshred/icons/dartboard.svg'
import DoubleArrowDown from '~/public/images/products/primeshred/icons/double-arrow-down.svg'
import Flame from '~/public/images/products/primeshred/icons/flame.svg'
import Unlink from '~/public/images/products/primeshred/icons/unlink.svg'
import HappyFace from '~/public/images/products/primeshred/icons/happy-face.svg'

import testimonialOne from '~/public/images/products/primeshred/testimonial-chris-usa.avif'
import testimonialTwo from '~/public/images/products/primeshred/testimonial-david-usa.webp'
import testimonialThree from '~/public/images/products/primeshred/testimonial-gary-usa.avif'
import testimonialFour from '~/public/images/products/primeshred/testimonial-frank-usa.avif'
import testimonialFive from '~/public/images/products/primeshred/testimonial-joshua-usa.avif'
import testimonialSix from '~/public/images/products/primeshred/testimonial-laramie-usa.avif'
import testimonialSeven from '~/public/images/products/primeshred/testimonial-mohammad-canada.avif'

import offerImage from '~/public/images/products/primeshred/offer.webp'

import socialImageOne from '~/public/images/products/primeshred/social-image-1.jpg'
import socialImageTwo from '~/public/images/products/primeshred/social-image-2.webp'
import socialImageThree from '~/public/images/products/primeshred/social-image-3.jpg'
import socialImageFour from '~/public/images/products/primeshred/social-image-4.jpg'

import ingredientsList from '~/public/images/products/primeshred/ingredients-list.png'

const isOpen = ref(false)
</script>

<template>
	<Content>
		<PageHeader
			:item-icon="CaretRight"
			:items="[
				'Fast, whole body fat burning',
				'Clinically backed ingredients',
				'Vegetarian & vegan friendly',
				'Advanced, high potency formula',
			]"
			button-text="Order now"
			button-link="#checkout"
			:main-image="ProductHeader"
			:background="`center / cover no-repeat url(${Background})`"
			text-color="color-white"
			item-size="m"
			sub-text="100% Secure Checkout">
			<template #header>
				<h1 class="text-white uppercase md:text-5xl md:text-balance">
					MALE FAT BURNER - SHRED FAT, GET LEAN AND TRANSFORM YOUR BODY
				</h1>
			</template>

			<template #subHeader>
				<h2 class="font-medium color-primary md:text-4xl md:text-balance">
					WITHOUT LOSING ENERGY OR MUSCLE MASS
				</h2>
			</template>
		</PageHeader>

		<div class="bg-[#000000]">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 grid md:grid-cols-3 gap-8 text-white">
				<UspItem
					v-for="{ icon, text } in [
						{
							icon: 'ph:airplane-tilt',
							text: 'Free shipping',
						},
						{
							icon: 'ph:shield-check',
							text: 'Secure checkout',
						},
						{
							icon: 'ph:arrow-clockwise',
							text: 'Money back guarantee',
						},
					]"
					:icon="icon"
					:text="text.toUpperCase()"
					text-color="text-white"
					size="sm"
					text-size="lg" />
			</div>
		</div>

		<div class="bg-white relative">
			<img
				class="hidden lg:block absolute top-0 bottom-0 h-full"
				src="~/public/images/products/primeshred/block-image-1.webp" />

			<div
				class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 grid lg:grid-cols-[1fr,2fr] text-black relative">
				<div></div>
				<div>
					<h2 class="!text-4xl font-bold text-black md:text-4xl md:text-balance">
						Hardcore fat burner for the most ripped, lean, shredded body you've ever had
					</h2>

					<p class="text-black !text-base !text-xl mb-6">
						<strong
							>PrimeShred is a high-potency fat burner scientifically formulated to deliver extreme fat
							burning and accelerated weight loss.</strong
						>
						The powerful combination of proven ingredients will give you fast, whole body fat burning and a
						boost in energy, mood and mental focus to help you achieve your best physique.
					</p>

					<div class="grid md:grid-cols-2 gap-4">
						<div
							v-for="item in [
								{
									icon: Flame,
									title: 'Lose pure fat and transform your body',
									text: 'Burn through calories and shred body fat to reveal pure, lean muscle for a perfectly ripped physique.',
								},
								{
									icon: Unlink,
									title: 'Break through frustrating plateaus',
									text: 'Jump start your body back into fat burning mode and. get the scale moving again whenever your results have.',
								},
								{
									icon: Dartboard,
									title: 'Dial it in whenever you want to get in peak shape',
									text: 'Reliably shift fat and be body ready for vacations, weddings, reunions, competitions or photo shoots.',
								},
								{
									icon: DoubleArrowDown,
									title: 'Strip off those last few pounds of stubborn fat',
									text: 'Stop getting stuck on those final pounds and strip off the fat all the way to six pack abs.',
								},
							]"
							class="flex flex-col items-center gap-4 p-4 bg-[#000000] rounded-lg">
							<img class="w-10 h-10" :src="item.icon" />

							<p class="font-bold !text-base md:!text-xl text-center text-white uppercase my-0">
								{{ item.title }}
							</p>
							<p class="!text-base md:!text-lg text-center text-white my-0">{{ item.text }}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="bg-[#000000] pt-12 px-8 pb-8">
			<a
				class="btn btn-primary btn-large !text-xl !tracking-normal flex items-center justify-center max-w-full w-80 mx-auto"
				href="#checkout">
				Order Now
				<Icon name="ph:caret-right-fill" />
			</a>

			<p class="flex items-center justify-center gap-1 !text-base text-white text-center mt-2 mb-0">
				<Icon name="ph:shield-check-fill" class="w-5 h-5" />
				100% Secure Checkout
			</p>
		</div>

		<div class="bg-white relative">
			<img
				class="hidden lg:block absolute top-0 right-0 bottom-0 h-full"
				src="~/public/images/products/primeshred/block-image-2.jpg" />

			<div
				class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 grid lg:grid-cols-[2fr,1fr] text-black relative">
				<div>
					<h2 class="!text-4xl font-bold text-black md:text-balance text-center">
						Advanced, triple threat fat loss formula for extreme fat burning
					</h2>

					<p class="text-black !text-base !text-xl mb-6">
						PrimeShred kicks fat-burning into high gear and converts even the most stubborn stored fat into
						usable energy..<br /><br />
						It's 3-stage approach to fat loss improves the efficacy of your body's own fat- burning
						processes, boosts your energy and enhances your mental focus, helping you quickly and
						effectively achieve your lean physique goals.
					</p>

					<div class="flex flex-col gap-4">
						<div
							v-for="(item, index) in [
								{
									title: 'Accelerates your body\'s own natural fat-burning processes for maximum calorie burn',
									text: 'PrimeShred fires up thermogenesis and accelerates your metabolic rate. Which means more calories and more stored fat can be burned as fuel for energy. Even while you\'re doing nothing..',
								},
								{
									title: 'PrimeShred triggers hormones known to have a direct effect on fat burning.',
									text: 'These hormones tell your fat cells to release stored fatty acids into your bloodstream where they can be burned away for good.',
								},
								{
									title: 'Amplifies your energy and mental focus to make cutting easier',
									text: 'Diets and intense cutting routines can leave you feeling burnt out, weak and mentally. drained. PrimeShred fuels your energy levels and helps you fight fatigue, while brain- boosting nootropics blow away the brain fog to keep you feeling sharp and focused each and every day.',
								},
							]"
							class="flex gap-4">
							<div
								class="min-w-8 w-8 h-8 rounded-full bg-[#000000] flex items-center justify-center text-white">
								{{ index + 1 }}
							</div>
							<div class="flex flex-col gap-4">
								<p class="font-bold !text-base md:!text-xl my-0 text-black">{{ item.title }}</p>
								<p class="!text-base md:!text-lg my-0 text-black">{{ item.text }}</p>
							</div>
						</div>
					</div>
				</div>
				<div></div>
			</div>
		</div>

		<div class="relative bg-[#000000] overflow-hidden" style="--color-primary: #ffffff">
			<img
				class="absolute inset-0 w-full h-full object-cover scale-110"
				src="~/public/images/products/primeshred/block-image-3.png" />

			<div class="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-20">
				<h2 class="!text-4xl font-bold text-white md:text-balance text-center uppercase">
					Plus! Bonus Mood Boosting Complex Banishes the Cutting Blues!
				</h2>

				<p class="text-white !text-base !text-xl mb-6">
					Calorie deficits and intense cutting routines can really mess with your mood. One minute you're
					feeling pumped after a great workout. The next, you're inexplicably about to blub. PrimeShred is
					loaded with mood-boosting ingredients to help keep those unpredictable emotions in check. Making it
					easier for you to stay positive and motivated to achieve your goals.<br /><br />
					Whether you're getting cut after bulking season or you want to finally get that lean body you've
					always desired,
					<strong>PrimeShred will help you burn fat fast and get lean quickly and effectively.</strong>
					Without surrendering your energy levels or sacrificing your hard-earned muscle gains.
				</p>

				<a
					class="btn btn-primary btn-large !text-xl !tracking-normal flex items-center justify-center max-w-full w-80 mx-auto"
					href="#checkout">
					Learn more
					<Icon name="ph:caret-right-fill" />
				</a>
			</div>
		</div>

		<div class="bg-yellow-400 relative py-12">
			<div class="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 bg-white rounded-lg">
				<h2 class="!text-3xl md:!text-4xl font-bold text-black md:text-balance text-center">
					The most effective, scientifically. backed ingredients for round-the-clock fat burning
				</h2>

				<p class="text-black !text-base !text-xl mb-6 text-center">
					Our experts at PrimeShred labs have exhaustively researched and developed the most up to date,
					cutting edge formula for fast, effective fat burning.<br /><br />
					PrimeShred uses extensively tested and proven ingredients like cayenne pepper, caffeine and green
					tea extract at the dosages used in the clinical studies.<br /><br />
					Which means you get maximum results in the quickest time, in one easy to take formula.
				</p>
			</div>

			<div class="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 mt-8">
				<div class="rounded-lg bg-white">
					<button
						@click="isOpen = !isOpen"
						class="w-full px-6 py-4 flex items-center justify-between rounded-lg text-lg font-semibold uppercase"
						:class="isOpen ? 'bg-black text-white' : 'bg-white text-black hover:bg-black hover:text-white'">
						View ingredients
						<Icon :class="{ 'rotate-180': isOpen }" name="ph:caret-down-fill" class="w-6 h-6" />
					</button>

					<div
						class="grid transition-all duration-300 ease-out"
						:style="{ gridTemplateRows: isOpen ? '1fr' : '0fr' }">
						<div class="overflow-hidden">
							<div class="px-6 py-4">
								<div
									v-for="ingredient in [
										{
											name: 'Green Tea Extract - 500mg',
											description:
												'Accelerates fat burning by speeding up your metabolism and boosting the effects of fat-burning hormones such as norepinephrine. Has also been found to reduce triglyceride levels, a form of fat stored in your fat cells.',
										},
										{
											name: 'L-Tyrosine - 300mg',
											description:
												'Enhances your focus, alertness and concentration by delaying the depletion of neurotransmitters that play a key role in your mental cognition, particularly during stressful situations like tough workouts.',
										},
										{
											name: 'Rhodiola Root - 250mg',
											description:
												'Triggers fat burning by activating an enzyme that breaks down stored fat. Improves your energy levels and enhances your performance by increasing oxygen transportation to your muscles, making tough training sessions more manageable.',
										},
										{
											name: 'Caffeine Anhydrous - 225mg',
											description:
												'Stimulates your metabolism and boosts fat burning by increasing production of key fat-burning hormones that break down fatty acids inside your fat cells. Also enhances your energy, focus and alertness.',
										},
										{
											name: 'Cayenne Pepper - 200mg',
											description:
												'Fires up your metabolism and increases thermogenesis, helping you burn more calories and fat. Also boosts the activity of key fat-burning enzymes and your energy levels and helps speed the rate of fat breakdown.',
										},
										{
											name: 'DMAE - 150mg',
											description:
												'Improves focus, alertness and your mind-muscle connection in the gym by increasing production of acetylcholine, a critical neurotransmitter for cognitive performance and muscle contraction.',
										},
										{
											name: 'Green Coffee - 100mg',
											description:
												'Contains chlorogenic acid which reduces glucose absorption and minimizes insulin spikes, helping to maintain stable blood sugar levels and prevent fat storage.',
										},
										{
											name: 'Vitamin B Complex',
											description:
												' B vitamins contribute to a normal, energy-yielding metabolism and help reduce tiredness and fatigue. Each serving of PrimeShred contains 15mg of vitamin B3, 1.3mg of vitamin B6 and 24mcg of vitamin B12.',
										},
										{
											name: 'Bioperine - 5mg',
											description:
												' Improves the bioavailability of the ingredients in PrimeShred by up to 30%. Which means your body absorbs the ingredients faster and more easily, ensuring you get the maximum benefit from each active ingredient.',
										},
										{
											name: 'Vegetable Capsule',
											description:
												' Plant-based vegetable capsules made from hypromellose are suitable for vegetarians, vegans and anyone wanting to avoid animal-derived products.',
										},
									]"
									:key="ingredient.name"
									class="pb-6 last:pb-0">
									<p class="!text-base md:!text-xl font-semibold text-black my-0">
										{{ ingredient.name }}
									</p>
									<p class="!text-base md:!text-lg text-black my-0">{{ ingredient.description }}</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="bg-[#f2f0eb]">
			<div
				class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 grid md:grid-cols-[2fr,1fr,3fr] items-center gap-8 text-black">
				<img src="~/public/images/products/primeshred/box-image.png" />
				<div class="hidden md:flex flex-col items-end gap-4">
					<img class="w-32" src="~/public/images/products/primeshred/manufactured-in-usa.png" />
					<img class="w-32" src="~/public/images/products/primeshred/free-from-sticker.png" />
					<img class="w-32" src="~/public/images/products/primeshred/no-gmo-ingredients.png" />
					<img class="w-32" src="~/public/images/products/primeshred/nothing-artificial.webp" />
				</div>
				<div>
					<h2 class="!text-4xl font-bold text-black md:text-balance">100% transparent formula</h2>

					<p class="text-black !text-base md:!text-lg">
						Every fat burner claims to be superior. But look closer and you’ll find many conceal their
						formulas in mystery proprietary blends. This is to hide the fact that they use inferior
						ingredients at weak, ineffective amounts.<br /><br />
						This saves them money, but leaves you out of pocket and out of results.<br /><br />
						Unlike many other products on the market,
						<strong
							>every single ingredient in PrimeShred is fully disclosed, including their exact
							amounts.</strong
						>
						There’s no fillers, no “secret” ingredients and absolutely no proprietary blends.<br /><br />
						PrimeShred is also manufactured in an FDA approved, GMP certified facility under the strictest
						quality control conditions, using only the safest, highest quality ingredients.<br /><br />
						Which means you can trust you’ll always know exactly what you’re getting when you purchase
						PrimeShred.
					</p>
				</div>
			</div>
		</div>

		<div class="bg-[#000000] pt-12 px-8 pb-8">
			<a
				class="btn btn-primary btn-large !text-xl !tracking-normal flex items-center justify-center max-w-full w-80 mx-auto"
				href="#checkout">
				Order Now
				<Icon name="ph:caret-right-fill" />
			</a>

			<p class="flex items-center justify-center gap-1 !text-base text-white text-center mt-2 mb-0">
				<Icon name="ph:shield-check-fill" class="w-5 h-5" />
				100% Secure Checkout
			</p>
		</div>

		<div class="bg-[#ededed]">
			<div class="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-12 text-black">
				<h2 class="!text-3xl md:!text-5xl font-bold text-black">
					Your iron-clad "shred of your life" guarantee
				</h2>

				<p class="!text-2xl font-bold text-[#f9be07] uppercase">Jaw-dropping results or your money back</p>

				<p class="text-black !text-base md:!text-lg">
					Other brands will try to make it as difficult as possible for you to claim a refund. They know they
					need to offer you a guarantee to persuade you to buy. But once they've got your money they'll do
					everything they can to keep<br /><br />
					So they design their refund policies specifically to make you less likely to claim a refund. They
					figure you'll figure it's just not worth it. And if you do make a claim they'll make you jump
					through multiple, ridiculous hoops to get your money back.<br /><br />
					That's because they know their products aren't really good enough to give you the results they've
					promised you. But once they've pocketed your money, they don't care whether it works for you or
					not.<br /><br />
					<strong>PrimeShred is different.</strong>
				</p>
			</div>
		</div>

		<div class="bg-[#fafafa]">
			<div
				class="grid md:grid-cols-[2fr,3fr] gap-8 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12 text-black">
				<div class="relative">
					<img class="hidden md:block w-full" src="~/public/images/products/primeshred/block-image-4.webp" />

					<img
						class="mx-auto md:absolute top-1/4 right-0 max-w-[50%] w-64"
						src="~/public/images/products/primeshred/100-days-guarantee.png" />
				</div>
				<div>
					<h2 class="!text-3xl md:!text-4xl font-bold text-black mt-0">
						Your iron-clad, 100-day "shred of your life" guarantee JAW-DROPPING RESULTS OR YOUR MONEY BACK
					</h2>

					<p class="!text-2xl font-bold text-[#f9be07] uppercase">Here's the deal:</p>

					<p class="text-black !text-base md:!text-lg/5">
						<strong>PrimeShred works.</strong><br /><br />
						It WILL help you burn fat from your entire body – even those last few stubborn pounds.<br /><br />
						It WILL give you the energy and focus you need to maintain your training intensity during your
						cut.<br /><br />
						And it WILL make your cut more bearable by minimizing mood swings and boosting your mood.<br /><br />
						Nonetheless…<br /><br />
						<strong
							>If, after putting maximum effort into your diet and training alongside taking PrimeShred as
							directed for at least 50 days, you don’t believe PrimeShred is helping you achieve your
							cutting goals, simply email us within 50-100 days of receiving your order and we’ll refund
							your money, excluding a $15 fixed fee to cover shipping and admin costs*.</strong
						><br /><br />
						Our money back guarantee applies to everything except a one month’s supply of PrimeShred. That’s
						because one month just isn’t long enough for you to truly experience the full force of
						PrimeShred and its incredible effects on your physique.<br /><br />
						Use PrimeShred alongside proper training, nutrition and dedication and you’ll soon see results
						so jaw-dropping you won’t even need this guarantee!<br /><br />
						<i
							>*Terms and conditions apply. Guarantee applies to purchases of over one month’s supply and
							only on first purchase. Click here to read the full terms of our refund policy.</i
						>
					</p>
				</div>
			</div>
		</div>

		<div class="relative bg-[#eeeeee]">
			<div class="absolute inset-0 w-full h-full">
				<div class="absolute inset-0 w-full h-full bg-white opacity-90 z-10"></div>
				<img class="absolute inset-0 w-full h-full object-cover" src="~/public/images/products/primeshred/block-image-5.jpg" />
			</div>

			<div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
				<h2 class="!text-3xl md:!text-5xl font-bold text-black mt-0 mb-8 text-center">Our guarantee to you</h2>

				<div class="grid md:grid-cols-3 gap-4 pb-4 border-b border-black">
					<div
						v-for="item in [
							{
								title: 'The longest guarantee on the market',
								text: 'Some policies insist you use the product for a certain amount of time before you can request a refund. Then give you a ridiculously tight timeframe in which to return it in the hope you won\'t make the deadline and they won\'t have to pay out PrimeShred gives you 100 days (that\'s over 3 months!) to return it if you\'re not happy with your results.',
							},
							{
								title: 'Nothing to return but your unused PrimeShred',
								text: 'We know of one policy that refused to pay out unless you returned all the empty bottles and original packaging - including the bag the product was delivered in! That\'s just crazy! All we ask you to return is any unopened, unused PrimeShred. Which is fair, right?',
							},
							{
								title: 'Fuss-free, no questions asked refund process',
								text: 'No third-degree interrogations, no complicated form to complete and nothing scary to sign. Just get in touch, request your refund and send any unopened product back. That\'s it.',
							},
						]">
						<div class="flex flex-col gap-2">
							<p class="font-bold !text-base md:!text-xl my-0 text-black uppercase">{{ item.title }}</p>
							<p class="!text-base md:!text-lg my-0 text-black">{{ item.text }}</p>
						</div>
					</div>
				</div>

				<a
					class="btn btn-primary btn-large !text-xl !tracking-normal flex items-center justify-center max-w-full w-80 mx-auto mt-8"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-fill" />
				</a>

				<!-- paragraph -->
				<p class="max-w-2xl mt-8 mb-0 mx-auto text-black !text-base md:!text-lg">
					Our money back guarantee applies to everything except a one month's supply of PrimeShred That's because one month just isn't long enough for you to truly experience the full force of PrimeShred and it's incredible effects on your physique.<br /><br />
					<strong>Use PrimeShred alongside proper training, nutrition and dedication and you'll soon see results so jaw-dropping you won't even need this guarantee!</strong>
				</p>
			</div>
		</div>

		<CardList
			:items="[
				{
					text: 'So far / have used PrimeShred for 1 month and <strong>already look and feel much better</strong>. I began working out again and altered my diet and PrimeShred helped force me to fast a little in the morning which really feel helped me. <strong>I have lost 5 pounds</strong> in the month since I1 started taking PrimeShred and I\'m feeling amazing.',
					name: 'David, USA',
					image: testimonialOne,
				},
				{
					text: 'I have purchased and have been using Prime Shred for 2 months. I purchased Prime Shred to shred fat and because of the ingredients full disclosure. <strong>PrimeShred has given me the energy and stamina</strong> to workout and stay physically active.<br />STILL GETTING IT AT 62 YEARS OLD',
					name: 'Frank, USA',
					image: testimonialTwo,
				},
				{
					text: 'PrimeShred has helped me in <strong>boosting energy, suppressing my appetite and helping me on my weight loss journey</strong>. I didn’t realize the appetite suppressant feeling is making you feel full, not just removing your appetite. When I want to eat out of habit, drinking water or lightly snacking bring on a full feeling pretty quickly.',
					name: 'Laramie, USA',
					image: testimonialThree,
				},
				{
					text: 'I started using Primeshred 6 weeks ago. After starting this, I feel more energetic, and could lose <strong>2 Kg in 6 weeks</strong>.<br /><br />Besides my exercise, <strong>I feel more energetic during the day and workout</strong>. I love it.',
					name: 'Mohammad, Canada',
					image: testimonialFour,
				},
				{
					text: 'Unlike other fat burners that usually make me very jittery, I had minimal side effects if any. I wanted to try something new to help get rid of that stubborn fat around the midsection that I can\'t seem to get rid of as I get into my 40s. <strong>I definitely look more toned after the month of use</strong>, especially with continuing to lift weights.',
					name: 'Gary, USA',
					image: testimonialFive,
				},
				{
					text: 'PrimeShred is simply the <strong>best fat burner I’ve used</strong>. With the combination of following an exercise program and a good diet, PrimeShred <strong>helped me to burn off some of the excess fat</strong> I was holding going into the summer last year. Highly, highly recommend this product!',
					name: 'Joshua, USA',
					image: testimonialSix,
				},
				{
					text: 'I have used prime shred for two months.<br /><br /><strong>I have lost 23 pounds</strong>, most around my waist and thighs and I’ve packed on the muscle.',
					name: 'Chris, USA',
					image: testimonialSeven,
				},
			]"
			:slider="true"
			:per-page="2"
			:pagination="false"
			:padding="{
				right: '20%',
			}"
			background="bg-[#eeeeee]">
			<template #header>
				<h2 class="!text-3xl md:!text-5xl font-bold text-black mt-0 mb-8 text-center text-balance">
					Hear What Our Satisfied Customers Have to Say About PrimeShred.
				</h2>
			</template>

			<template #slides="{ items }">
				<SplideSlide
					v-for="(item, index) in items"
					:key="index"
					class="flex flex-col gap-4 md:gap-8 bg-white p-6 rounded-lg">
					<p class="!text-base text-black my-0"
						v-html="`&quot;${item.text}&quot;`"></p>

					<div class="flex gap-4 justify-center items-center">
						<img class="h-20 rounded-tr-[2.5rem] rounded-br-[2.5rem]" :src="item.image" />

						<div>
							<p class="!text-base text-black my-0 text-start">
								{{ item.name }}
							</p>

							<p class="!text-base text-black my-0 font-bold text-start">
								Verified Buyer
							</p>
						</div>
					</div>
				</SplideSlide>
			</template>

			<template #footer>
				<p class="my-0 mx-auto text-black !text-base md:!text-lg">
					<strong>Ready to experience the same great results?</strong> Click the button below to get started!
				</p>

				<a
					class="btn btn-primary btn-large !text-xl !tracking-normal flex items-center justify-center max-w-full w-80 mx-auto mt-4"
					href="#checkout">
					Order Now
					<Icon name="ph:caret-right-fill" />
				</a>
			</template>
		</CardList>

		<Offer
			product-title="PRIMESHRED - MALE FAT BURNER"
			rated-text="Rated 4.6/5 by thousands of slimmer customers"
			product-description="Shred fat, get lean and transform your body"
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTg0MTAyOTMsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA3MDk0NzYxMjI5MzMsICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA5NzE1NTQxNjM3M31dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463018410293:1?channel=buy_button"
			:subscribe-price="47.99"
			:discounted-price="59.99"
			:original-price="69.99"
			:product-image="offerImage"
			background="bg-[#000000]"
			text-color="#ffffff">
			<template #header>
				<h2 class="!text-3xl md:!text-5xl font-bold text-white mt-0 mb-8 text-center">
					Ready to get shredded?
				</h2>

				<p class="!text-base md:!text-xl text-white text-center mb-0">
					Choose your PrimeShred package now and get ready for the cut of your life!
				</p>

				<ul class="flex gap-8 justify-center mt-8 flex-wrap">
					<li
						v-for="item in [
							{
								icon: Flame,
								text: 'Burn body fat fast',
							},
							{
								icon: DoubleArrowDown,
								text: 'Boost energy & focus'
							},
							{
								icon: HappyFace,
								text: 'Beat the cutting blues',
							},
						]"
						class="flex gap-2 items-center"
					>
						<img class="w-8 h-8" :src="item.icon" />
						<p class="!text-base md:!text-xl text-white my-0">{{ item.text }}</p>
					</li>
				</ul>
			</template>
		</Offer>

		<div class="bg-white">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-8 grid md:grid-cols-3 gap-8 text-black">
				<UspItem
					v-for="{ icon, text } in [
						{
							icon: 'ph:airplane-tilt',
							text: 'Free shipping',
						},
						{
							icon: 'ph:shield-check',
							text: 'Secure checkout',
						},
						{
							icon: 'ph:arrow-clockwise',
							text: 'Money back guarantee',
						},
					]"
					:icon="icon"
					:text="text.toUpperCase()"
					text-color="text-black"
					size="sm"
					text-size="lg" />
			</div>
		</div>

		<Faqs
			header="Frequently asked questions"
			background="#eeb607"
			item-background="#ffffff"
			:questions="[
				{
					question: 'Where can I buy PrimeShred?',
					answer: `PrimeShred is available to purchase from the website HealthNutrition.com and is also available on <a href='https://www.amazon.com/PrimeShred-Supplement-Caffeine-Thermogenic-Suppressant/dp/B0BX3Q3MTM/' target='_blank'>Amazon.com</a>, <a href='https://www.walmart.com/ip/PrimeShred-Diet-Pills-Thermogenic-Weight-Loss-Maximum-Strength-Fat-Burner-Appetite-Suppressant/5055510026' target='_blank'>Walmart.com</a> and other select suppliers. &nbsp;Currently PrimeShred is not available at GNC or other local retailers. We recommend purchasing directly at <a href='https://healthnutrition.com/products/primeshred#gPba3HTsB9'>HealthNutrition.com</a> to avoid fake or counterfeit products.`,
				},
				{
					question: 'How do I take PrimeShred?',
					answer: `Take three PrimeShred capsules approximately 20 minutes before your breakfast. You should take PrimeShred on both training and non-training days.`,
				},
				{
					question: 'What is in PrimeShred?',
					answer: `
						You can view the PrimeShred product label below.
						<img src='${ingredientsList}' />
					`,
				},
				{
					question: 'How long does PrimeShred one tub last?',
					answer: `Each tub contains 30 servings (90 capsules) which will last you 30 days.`,
				},
				{
					question: 'Are there any side effects with PrimeShred?',
					answer: `No. PrimeShred is made from 100% natural ingredients, meaning our formula is completely safe and free from all side effects.`,
				},
				{
					question: 'Is PrimeShred vegan / dairy free?',
					answer: `
						Yes, PrimeShred is 100% free of meat, eggs, dairy products, and any other animal-derived substances.<br /><br />
						PrimeShred is also soy, gluten and GMO free and contains absolutely no artificial colors, sweeteners or preservatives.
					`,
				},
				{
					question: 'Where is PrimeShred manufactured?',
					answer: `We are proud to say that PrimeShred is 100% manufactured in the United States of America in an FDA approved, GMP certified facility.`,
				},
				{
					question: 'Can women use PrimeShred?',
					answer: `
						Yes! PrimeShred isn’t just for men, even though most of our customers are male.<br /><br />
						PrimeShred is a hardcore fat burner that will help you burn fat fast and effectively, regardless of your gender.<br /><br />
						However, you should not use PrimeShred if you are pregnant or breastfeeding.
					`,
				},
				{
					question: 'Where do you ship PrimeShred?',
					answer: `We ship PrimeShred to USA, UK & Canada.`,
				},
				{
					question: 'Do you offer a money-back guarantee?',
					answer: `Yes. We have an industry-leading 100 day money-back guarantee. If you’re not 100% satisfied with your purchase, let us know and we will refund your money (excluding any shipping charges) without any hassle.`,
				},
			]" />

		<div class="bg-[#EDEDED]">
			<div class="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 md:py-12">
				<div class="flex justify-center items-center gap-8 flex-wrap">
					<img class="w-36" src="~/public/images/products/primeshred/prime-shred-logo.png" />

					<div class="font-bold text-3xl">@primeshred</div>
				</div>

				<div class="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8">
					<img
						v-for="(item, index) in [
							socialImageOne,
							socialImageTwo,
							socialImageThree,
							socialImageFour,
						]"
						:key="index"
						:src="item"
						class="aspect-square object-cover"
					/>
				</div>
			</div>
		</div>
	</Content>
</template>

<style scoped>
.content {
	--text-color: #000000;
	--color-primary: #f9be07;
	--button-text-color: #000000;
}
</style>

<style>
.text-color {
	color: var(--text-color);
}

.color-primary {
	color: var(--color-primary);
}

.btn-primary {
	background: var(--color-primary);
	color: var(--button-text-color);
}
</style>
